<script>
    import RepairCard from "$lib/Components/Order/RepairCard.svelte";
    import CTA from "$lib/Components/Order/CTA.svelte";

    import bgImage from "$lib/assets/images/order/pricing-bg-img.png";
    import engineThumbnail from "$lib/assets/images/parts/engine.jpg";
    import exhaustThumbnail from "$lib/assets/images/parts/exhaust.jpg";
    import hvacThumbnail from "$lib/assets/images/parts/HVAC.jpg";
    import transmissionThumbnail from "$lib/assets/images/parts/transmission.jpg";
    const repairCardsData = [
        {
            title: "Engine",
            image: engineThumbnail,
            price: 3250,
        },
        {
            title: "Transmission",
            price: 1500,
            image: transmissionThumbnail,
        },
        {
            title: "Exhaust",
            image: exhaustThumbnail,
            price: 850,
        },
        {
            title: "HVAC",
            price: 450,
            image: hvacThumbnail,
        },
    ];
</script>

<section class="section-container">
    <div class="pricing-container">
        <div class="w-full right">
            <CTA titleFont="text-primary-800" isLight={false} text="Check out the national average pricing for everyday repairs" title="Ready to stop stressing over costly repairs?" button="Certify Your Vehicle"></CTA>
        </div>
        <div class="w-full left">
            <div class="scrollboxanimation snap-x scroll-px-4 snap-mandatory repair-cards scroll-smooth flex overflow-x-auto px-4 py-10">
                {#each repairCardsData as card}
                    <RepairCard title={card.title} imageLink={card.image} price={card.price} />
                {/each}
            </div>
        </div>
    </div>
</section>

<style>
    .repair-cards {
        scrollbar-gutter: none;
        scrollbar-width: none;
        padding: 2rem 0;
        gap: 1rem;
        /* margin: 2rem 0; */
    }
    .scrollboxanimation {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        /* margin: 2rem 0; */
        gap: 1rem;
        /* margin: 2rem 0; */
        width: 100%;
        height: 100%;
        padding: 2rem 0;
        overflow-x: scroll;
        scroll-snap-type: x mandatory;
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;
        animation: scroll 2s cubic-bezier(0.4, 0, 0.2, 1) forwards;
    }
    @keyframes scroll {
        0% {
            transform: translateX(0);
        }
        50% {
            transform: translateX(calc(-20% + 10rem));
        }
        100% {
            transform: translateX(0);
        }
    }
    section {
        @apply bg-white;

        /* background-blend-mode: overlay; */
        background-repeat: no-repeat;
        background-position: center;

        background-size: cover;
        background-position: left;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: auto;
        flex-grow: 1;
    }
    .pricing-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        margin: auto;
        width: 100%;

        margin: auto;
    }
    .right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-items: center;

        height: 100%;
        margin: auto;
        flex-grow: 1;
        box-shadow: -10px 0px 4px white;
        padding: 1rem 2rem;
        justify-content: center;
    }

    .left {
        display: flex;
        flex-direction: column;
        width: 100%;
        overflow-x: scroll;
        gap: 1rem;
        max-width: 1200px;
        margin: auto;
        flex-grow: 1;
        /* padding: 2rem; */
    }
    .section-container {
        padding: 2rem 0;
    }
    @media screen and (min-width: 768px) {
        .pricing-container {
            flex-direction: row-reverse;
        }
        .left {
            display: flex;
            width: 52%;
            min-width: none;
        }
        .right {
            width: 48%;
            min-height: 379px;
        }
    }
</style>
